export const assessmentQuestionType = {
  freeText: 1,
  dropDown: 2,
  textarea: 3,
  date: 4,
  checkboxText: 5,
  checkboxQuestion: 6,
  linearScale: 7,
  tickBoxGrid: 9,
  multipleChoiceGrid: 8,
  Checkboxes: 10,
  textOnly: 11,
  CheckboxesQuestionDynamic: 12,
  CheckboxesFurtherInfo: 13,
  dateAndTime: 14,
  multipleCheckboxGridScore: 15,
  checkboxGridScore: 16,
  checkboxScore: 17,
}

export const optionType = {
  single: 0,
  multiple: 1,
}
